export const PASSPORT_REQUIRED_UPDATE_FIELDS = {
  passportKey: 'passportKey',
  passportValidity: 'passportValidity',
};
